import { render } from "./TermsCheck.vue?vue&type=template&id=2c61dc38&scoped=true"
import script from "./TermsCheck.vue?vue&type=script&lang=js"
export * from "./TermsCheck.vue?vue&type=script&lang=js"

import "./TermsCheck.vue?vue&type=style&index=0&id=2c61dc38&lang=scss&scoped=true"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c61dc38"]])

export default __exports__